const registerForm = document.getElementById('register-form');
const grSiteKey = document.querySelector('[data-gr-site-key]');
if (registerForm && grSiteKey){
    registerForm.addEventListener('submit', function(e) {
        e.preventDefault();
        grecaptcha.enterprise.ready(function() {
            grecaptcha.enterprise.execute(grSiteKey.dataset.grSiteKey, {action: 'submit'}).then(function(token) {
                // Add token to form as hidden input
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'g-recaptcha-response';
                input.value = token;
                registerForm.appendChild(input);
                registerForm.submit();
            });
        });
    });
}
